<app-card orientation="vertical" [interactive]="true" (click)="viewOpenPositions()">
  <div class="company-card__head">
    <div class="company-card__media">
      <img *ngIf="company.logo" [src]="company.logo" [alt]="company.name" />
      <div *ngIf="!company.logo" class="company-logo-placeholder">
        <i class="fas fa-building" aria-hidden="true"></i>
      </div>
    </div>
    <div class="company-card__head-text">
      <h3 class="company-card__title">{{ company.name }}</h3>
      <div class="company-card__address" *ngIf="company.address">
        <i class="fas fa-map-marker-alt" aria-hidden="true"></i>
        <span>{{ company.address }}</span>
      </div>
    </div>
  </div>

  <div class="company-card__footer">
    <div class="company-card__positions-count" [ngClass]="positionsCountTier">
      <span class="count">{{ company.jobCount }}</span>
      <span class="label">{{ 'companies.openPositions' | transloco }}</span>
    </div>
    <app-button variant="outline" color="primary" size="sm" (click)="onButtonClick($event)">
      {{ 'companies.viewPositions' | transloco }}
    </app-button>
  </div>
</app-card>
